import { useMemo } from 'react';

import { usePetitionUpdatePageData } from '#src/app/pages/petitionUpdate/details/pageContext';

type Data = {
	updateId: string;
	kind: string;
	createdAt: string;
	authorId: string | undefined;
	decisionMakerId: string | undefined;
	petitionId: string;
	status: string;
	promotable: string;
	starterId: string;
	urls: {
		editUpdate: string;
		updateModeration: string;
		updateEmailLimits: string;
		authorAdmin: string | undefined;
		decisionMakerAdmin: string | undefined;
		petitionAdmin: string;
		dashboard: string;
		starterAdmin: string;
	};
};

type Result = ModelHookResult<Data>;

const yesNo = (value: boolean) => (value ? 'Yes' : 'No');

export function usePetitionUpdateStaffDrawer(): Result {
	const {
		data: { update },
	} = usePetitionUpdatePageData();
	const { id, kind, createdAtLocalized, petition } = update;
	const { id: petitionId, slug, status, promotable, user: starter } = petition;

	// only MilestonePetitionUpdate, EndorsementPetitionUpdate, and MediaSourcePetitionUpdate don't carry a `user`
	const authorId = 'user' in update ? update.user.id : undefined;
	const decisionMakerId =
		update.__typename === 'DmResponsePetitionUpdate' ? update.dmResponse.decisionMaker.id : undefined;

	const urls = useMemo(() => {
		const encodedSlug = encodeURIComponent(slug);
		return {
			editUpdate: `/p/${encodedSlug}/u/${id}/edit`,
			updateModeration: '/admin/petition_update_moderation',
			updateEmailLimits: '/admin/petition_update_email_limits',
			authorAdmin: authorId ? `/admin/u/${authorId}` : undefined,
			decisionMakerAdmin: decisionMakerId ? `/admin/decision-makers/${decisionMakerId}` : undefined,
			petitionAdmin: `/admin/p/${encodedSlug}`,
			dashboard: `/p/${encodedSlug}/dashboard`,
			starterAdmin: `/admin/u/${starter.id}`,
		};
	}, [slug, id, authorId, decisionMakerId, starter.id]);

	return {
		data: {
			updateId: id,
			kind,
			createdAt: createdAtLocalized,
			authorId,
			decisionMakerId,
			petitionId,
			status,
			promotable: yesNo(promotable),
			starterId: starter.id,
			urls,
		},
	};
}
